import { queryOptions } from '@tanstack/react-query';
import { getDamagedVehicleCorrectiveImageTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImageTabs/getDamagedVehicleCorrectiveImageTabsFunction';
import { getInitialVisitCorrectiveImageTabsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImageTabs/getInitialVisitCorrectiveImageTabsFunction';

export const getDamagedVehicleCorrectiveImageTabsOpions = (
  id: number,
  damaged_id: number,
  type?: 'initial' | 'property',
) => {
  const queryFn = () => {
    if (type && type === 'initial') {
      return getInitialVisitCorrectiveImageTabsFunction({
        id: id,
      });
    }
    return getDamagedVehicleCorrectiveImageTabsFunction({
      damaged_id: damaged_id,
      id: id,
    });
  };
  return queryOptions({
    queryKey: ['getDamagedVehicleCorrectiveImageTabsOpions', id, damaged_id],
    queryFn: () => queryFn(),
  });
};
